import { render, staticRenderFns } from "./BillInboxSidebar.vue?vue&type=template&id=de3ca4f0&scoped=true&"
import script from "./BillInboxSidebar.vue?vue&type=script&lang=js&"
export * from "./BillInboxSidebar.vue?vue&type=script&lang=js&"
import style0 from "./BillInboxSidebar.vue?vue&type=style&index=0&id=de3ca4f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de3ca4f0",
  null
  
)

export default component.exports